export const LOGIN = "/";
export const PODCASTS = "/podcasts";
export const SHOWS='/shows';
export const EPISODES='/shows/:id';